import { render, staticRenderFns } from "./OrderStateBadge.vue?vue&type=template&id=5e819324&v-if=this.label&"
import script from "./OrderStateBadge.vue?vue&type=script&lang=js&"
export * from "./OrderStateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports